<!-- Component for rendering the memorial guide form -->
<template>
	<FormKit
		type="form"
		:actions="false"
		:key="plan.id"
		v-model="planModel"
		:outer-class="outerClass"
	>
		<!-- For some reason date picker needs to be at the top level to show other date pickers -->
		<div class="hidden">
			<FormKit
				type="date"
				name="ignore"
				label="ignore"
				help="ignore"
				placeholder="ignore"
			/>
		</div>

		<!-- Sections -->
		<LazyRender
			:min-height="200"
			render-on-idle
		>
			<SectionVitalBasics
				:active-plan-index="index"
				:truncate="plan.encryptionStatus !== 'unencrypted'"
			>
				<ConfirmIdentity
					v-if="plan.encryptionStatus !== 'unencrypted'"
					class="my-4 w-full"
					:plan="plan"
				/>
			</SectionVitalBasics>
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="300"
			render-on-idle
		>
			<SectionPersonalIdentification :plan="plan" />
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="300"
			render-on-idle
		>
			<SectionOccupation :plan="plan" />
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="400"
			render-on-idle
		>
			<SectionSpouseInfo
				:active-plan-index="index"
				:plan="plan"
			/>
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="500"
			render-on-idle
		>
			<SectionParents
				:active-plan-index="index"
				:plan="plan"
			/>
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="80"
			render-on-idle
		>
			<SectionMilitaryRecord :active-plan="plan" />
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="200"
			render-on-idle
		>
			<SectionPersonsResponsible
				:active-plan-index="index"
				@add-person="addPersonResponsible"
			/>
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="200"
			render-on-idle
		>
			<SectionFuneralService
				:active-plan-index="index"
				:active-plan="plan"
			/>
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="300"
			render-on-idle
		>
			<SectionIntermentPreferences
				:active-plan="plan"
				:active-plan-index="index"
			/>
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="300"
			render-on-idle
		>
			<SectionSpecialInstructions :active-plan-index="index" />
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="300"
			render-on-idle
		>
			<SectionJewelry :active-plan-index="index" />
		</LazyRender>

		<LazyRender
			v-if="plan.encryptionStatus === 'unencrypted'"
			:min-height="60"
			render-on-idle
		>
			<SectionOther :active-plan-index="index" />
		</LazyRender>
	</FormKit>
</template>

<script setup lang="ts">
import LazyRender from '../common/LazyRender.vue'
import ConfirmIdentity from '../encryption/ConfirmIdentityInline.vue'
import SectionJewelry from './SectionJewelry.vue'
import SectionOccupation from './SectionOccupation.vue'
import SectionParents from './SectionParents.vue'
import SectionPersonalIdentification from './SectionPersonalIdentification.vue'
import SectionFuneralService from '@/components/memorialGuide/SectionFuneralService.vue'
import SectionIntermentPreferences from '@/components/memorialGuide/SectionIntermentPreferences.vue'
import SectionMilitaryRecord from '@/components/memorialGuide/SectionMilitaryRecord.vue'
import SectionOther from '@/components/memorialGuide/SectionOther.vue'
import SectionPersonsResponsible from '@/components/memorialGuide/SectionPersonsResponsible.vue'
import SectionSpecialInstructions from '@/components/memorialGuide/SectionSpecialInstructions.vue'
import SectionSpouseInfo from '@/components/memorialGuide/SectionSpouseInfo.vue'
import SectionVitalBasics from '@/components/memorialGuide/SectionVitalBasics.vue'
import { FormKit } from '@formkit/vue'
import { computed } from 'vue'

const props = defineProps<{
	plan: any
	index: number
	outerClass?: string
}>()

/**
 * Computed property that wraps the plan model.
 */
const planModel = computed({
	get: () => props.plan,
	set: (val) => props.plan.update(val),
})

/**
 * Adds a blank item to the end of peopleResponsible
 */
function addPersonResponsible() {
	props.plan.peopleResponsible.push({
		firstName: '',
		lastName: '',
		relationship: '',
		city: '',
		state: '',
		zip: '',
		phone: '',
		email: '',
		notes: '',
	})
}
</script>
